<template>
    <div>
        <keep-alive>
            <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">

            </el-form>
        </keep-alive>
        <tablePagination :total="total" :pageSize="formParam.pageSize" @handlePage="handlePage">
            <el-table :data="tableList" border size="mini">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="logisticsId" label="物流公司Id"></el-table-column>
                <el-table-column prop="logisticsCode" label="物流公司代码"></el-table-column>
                <el-table-column prop="logisticsName" label="物流公司名称"></el-table-column>
                <el-table-column label="对应小商店物流公司">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.shopId"
                                   filterable
                                   @change="saveLogistics(scope.row)"
                                   placeholder="请选择小商店物流公司">
                            <el-option v-for="item in logisticsList"
                                       :key="item.delivery_id"
                                       :label="item.delivery_name"
                                       :value="item.delivery_id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <!--          <el-table-column label="操作" fixed="right" width="140">
                            <template slot-scope="scope">
                                <el-button type="success" plain size="mini" @click="toDetail(scope.row.refundNo,scope.row.orderNo,2)">查看</el-button>
                            </template>
                          </el-table-column>-->
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formParam.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formParam.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
                </el-pagination>
            </div>
        </tablePagination>
    </div>
</template>

<script>
import {getMiniShopLogisticsList, saveLogisticsLink, getLogisticsList} from '@/api/api';

export default {
    data() {
        return {
            formParam: {
                pageSize: 50,
                currentPage: 1,
                recordsTotal: 0
            },
            tableList: [],
            logisticsList: []
        }
    },
    mounted() {
        this.initList();
        this.initLogistics();
    },
    methods: {
        initList() {
            getLogisticsList(this.formParam).then(res => {
                this.formParam.recordsTotal = res.data.value.total;
                this.tableList = res.data.value.list;
            });
        },
        initLogistics() {
            getMiniShopLogisticsList().then(res => {
                this.logisticsList = res.data.value;
            });
        },
        handlePage(page) {
            this.formParam.currentPage = page;
            this.initList();
        },
        // 更新物流信息
        saveLogistics(row) {
            // let _row = row;
            // console.log("row",row);
            // console.log("row.id",row.id);
            // console.log("row.tagName",row.tagName);
            // console.log("row.tmallCouponName",row.tmallCouponName);
            if (row.logisticsId == null) {
            } else {
                saveLogisticsLink(row).then(res => {
                    this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                    //this.initLogistics();
                });
            }
        },
        returnHistory() {
            window.history.back()
        },
        handleSizeChange(val) {
            this.formParam.pageSize = val;
            this.initList();
        },
        handleCurrentChange(val) {
            this.formParam.currentPage = val;
            this.initList();
        }
    }
}
</script>

<style scoped>
.expand-title {
    width: 70px;
    color: #444548;
    line-height: 30px;
    text-align: right;
    margin-right: 10px;
    font-weight: 600;
}

.expand-flex {
    justify-content: flex-start;
    align-items: center;
    align-content: center;
}
</style>


// WEBPACK FOOTER //
// src/views/deliver/mallDeliverLink.vue